import script from "./ClassicForgotPasswordStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassicForgotPasswordStep.vue?vue&type=script&setup=true&lang=js"

import "./ClassicForgotPasswordStep.vue?vue&type=style&index=0&id=c56e9ab2&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/actions-runner/_work/keepyoursight/keepyoursight/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c56e9ab2"]])

export default __exports__